import React from 'react';
import {ReactComponent as TrashIcon} from '../../media/icon-trash.svg';

type Props = {
  data: {
    logID?: number;
    userId: string;
    date: string;
    type: string;
    contact: string;
    message: string;
  };
  onDelete: (logData: any) => void;
};

const DeleteContactLogRenderer = (props: Props) => {
  const {data, onDelete} = props;

  const handleDelete = () => {
    if (data.logID) {
      // Only allow deletion if there's a logID (existing record)
      onDelete(data);
    }
  };

  // Don't show delete button for new entries without logID
  if (!data.logID) {
    return null;
  }

  return (
    <button 
      className='btn btn--danger' 
      onClick={handleDelete}
      title="Delete contact log entry"
      style={{ padding: '0.25rem', border: 'none', background: 'transparent', display: 'flex', alignItems: 'center', width: '100%', height: '100%', justifyContent: 'center' }}
    >
      <TrashIcon style={{ width: '16px', height: '16px' }} />
    </button>
  );
};

export default DeleteContactLogRenderer;
